module.exports = __webpack_public_path__ + "static/img/aboutus.1f23d45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutus.png
// module id = 6uiW
// module chunks = 36